import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'order',
    serviceName: 'auth',
    query: gql`
      query order($ids: [String]) {
        order(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
